/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState } from "react";
import DefaultBook from "../Images/defaultBook.png";
import GeetGovindServices from "../Services/GeetGovind";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Styles/BookDetail.css";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import Favfill from "../assets/img/favadd.svg";
import Favempty from "../assets/img/fav.svg";
import { BookContentType } from "./Epub";
import { userId } from "../Contexts/LocaleContext";
import { LogInModel } from "./LoginModel";
import leftArrow from "../assets/img/leftArrow1.png";
import rightArrow from "../assets/img/rightArrow1.png"
import closeicon from "../Images/close-round-border.svg"
import EpubServices from "../Services/Epub";
import { Breadcrumbs } from "./E-BooksComponent";
import bookmarkIcon from "../Images/Bookmark.svg"
import PdfIcon from "../Images/PDF.svg"
import Loader from "./Loader";
import BookCoverPopup from "../Components/BookCoverPopup";
import { getMonthNameFromNumber } from "../Components/MonthUtils";
import { listToTree } from "../utils/tocUtils";
import GeetGovindseo from "../Components/GeetGovindseo";

const PrevArrow = ({ className, style, onClick }: any) => (
  <div className={className} style={style} onClick={onClick}>
    <img src={leftArrow} alt="Previous" height="40px" />
  </div>
);

const NextArrow = ({ className, style, onClick }: any) => (
  <div className={className} style={style} onClick={onClick}>
    <img src={rightArrow} alt="Next" height="40px" />
  </div>
);

const GeetGovindDetailPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [geetgovindDetail, setGeetGovindDetail] = useState<any>(undefined);
  const [refresh, setRefresh] = useState(false);
  const [geetgovindId, setGeetGovindId] = useState("");
  const [relateds, setRelatedGeetGovind] = useState<any[] | undefined>(undefined);

  const location = useLocation();
  const [isLiked, setIsLiked] = useState<boolean>(false);
  const [showCoverPopup, setShowCoverPopup] = useState(false);
  const state = location.state as {
    geetgovindId?: string,
    MonthId?: string,
    geetgovindSlug?: string,
    monthSlug?: string,
    bookName?: string,
    slug?: string,
  };

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
  };

  const [logIn, setLogIn] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  const closeModal = () => {
    setLogIn(false);
  };

  const UserIdentity = localStorage.getItem("UserId") as any;

  const [toggleFav, setToggleFav] = useState<boolean>(false);

  const [bookMark, setBookMark] = useState<boolean>(false)
  const [bookMarkData, setBookMarkData] = useState<any[] | undefined | any>(undefined);
  const [description, setDescription] = useState({ __html: "" });
  const [activeTab, setActiveTab] = useState<'related' | 'description' | 'toc'>('related');
  const [expandedNodes, setExpandedNodes] = useState<Set<string>>(new Set());
  const [lastPos, setLastPos] = useState<any>(null);
  const [lastFontSize, setLastFontSize] = useState<number>(100);
  const [toc, setToc] = useState<any[]>([]);
  const [progress, setProgress] = useState<number>(0);
  const [navOrder, setNavOrder] = useState<number>(0);

  const navigationTree = useMemo(() => listToTree(toc), [toc]);
  const flatToc = useMemo(() => toc, [toc]);

  const notificationRef = useRef<any>(null);

  const showNotification = (message: any) => {
    notificationRef.current.innerText = message;
    notificationRef.current.style.display = 'block';

    setTimeout(() => {
      notificationRef.current.style.display = 'none';
    }, 3000); // Hide the notification after 2 seconds
  };

  const [loginState, setLoginState] = useState<boolean>(false);

  const toggleNode = (nodeId: string) => {
    setExpandedNodes((prev) => {
      const next = new Set(prev);
      if (next.has(nodeId)) {
        next.delete(nodeId);
      } else {
        next.add(nodeId);
      }
      return next;
    });
  };

  const renderTocNode = (node: any, index: number, flatIndex?: number) => {
    const isExpanded = expandedNodes.has(node.navId || `node-${index}`);
    const hasChildren = node.children && node.children.length > 0;

    const totalChapters = flatToc.length;
    const readCount = Math.floor((totalChapters * progress) / 100);
    const currentFlatIndex =
      flatIndex !== undefined
        ? flatIndex
        : flatToc.findIndex((n: any) => n.navId === node.navId);
    const isRead = currentFlatIndex !== -1 && currentFlatIndex < readCount;

    return (
      <li key={node.navId || index} className="toc-node">
        <div
          className={`node ${isRead ? "read" : "unread"}`}
          onClick={() => hasChildren && toggleNode(node.navId || `node-${index}`)}
          style={{ cursor: hasChildren ? "pointer" : "default" }}
        >
          {hasChildren ? (
            <span className="node-toggle">{isExpanded ? "-" : "+"}</span>
          ) : (
            <span className="node-bullet">•</span>
          )}
          <div
            className="node-label"
            onClick={(e) => {
              if (!hasChildren) {
                e.stopPropagation();
                navigate(`/reader/geetgovind/` + geetgovindDetail?.slug, {
                  state: {
                    magazineDetailId: geetgovindDetail?.id,
                    bookName: geetgovindDetail?.name,
                    slug: geetgovindDetail?.slug,
                    location:
                      node.srcFile + (node.srcAnchor ? `#${node.srcAnchor}` : "") ||
                      node.href,
                    tocNode: node,
                    type: BookContentType.magazine,
                  },
                });
              }
            }}
            style={{ cursor: "pointer" }}
          >
            {node.label || node.title}
          </div>
        </div>
        {hasChildren && (
          <ul className={`children ${isExpanded ? "expanded" : ""}`}>
            {node.children.map((child: any, cIdx: number) => {
              const childFlatIndex = flatToc.findIndex((n: any) => n.navId === child.navId);
              return renderTocNode(child, `${index}-${cIdx}` as any, childFlatIndex);
            })}
          </ul>
        )}
      </li>
    );
  };

  function createMarkup() {
    return { __html: description.__html };
  }

  const hasVisibleDescription = useMemo(() => {
    const html = description?.__html || "";
    const text = html
      .replace(/&nbsp;/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
    return text.length > 0;
  }, [description]);

  const hasToc = toc.length > 0;
  const hasRelateds = useMemo(() => !!(relateds && relateds.length > 0), [relateds]);

  const indicatorTranslate = useMemo(() => {
    const tabs = [];
    if (hasRelateds) tabs.push('related');
    if (hasVisibleDescription) tabs.push('description');
    if (hasToc) tabs.push('toc');

    const tabIndex = tabs.indexOf(activeTab);
    return `${tabIndex * 160}px`;
  }, [hasRelateds, hasVisibleDescription, hasToc, activeTab]);

  const handleLoginStateChange = (newState: any) => {
    setLoginState(newState === true);
    navigate(`/reader/geetgovind/` + geetgovindDetail.slug, {
      state: {
        magazineDetailId: geetgovindId,
        bookName: state?.bookName,
        slug: state?.geetgovindSlug || state?.monthSlug || state?.slug,
        type: BookContentType.magazine,
      },
    });
  };

  const notify = () => {
    if (UserIdentity) {
      showNotification(!isLiked
        ?
        localStorage.getItem("lan") === "hindi"
          ? "पत्रिका को सफलतापूर्वक मेरी पसंद में जोड़ा गया है।"
          : "Magazine has been successfully added to the favourites"
        : localStorage.getItem("lan") === "hindi"
          ? "पत्रिका मेरी पसंद से हटा दी गई है।"
          : "Magazine has been removed from favourites"
      )
    }
  };

  const toggleLike = () => {
    !isLiked
      ? GeetGovindServices.addGeetGovindFavourite(geetgovindId).then((res) => {
        res.status && setIsLiked(true);
      })
      : GeetGovindServices.removeGeetGovindFavourite(geetgovindId).then((res) => {
        res.status && setIsLiked(false);
      });
    setToggleFav((x) => !x);
  };

  const monthName = getMonthNameFromNumber(geetgovindDetail?.months);

  useEffect(() => {
    console.log('GeetGovindDetailPage - location.state:', location.state);
    if (location.state) {
      // Handle both MonthId and geetgovindId for backward compatibility
      const id = state?.geetgovindId || state?.MonthId;
      console.log('GeetGovindDetailPage - extracted id:', id);
      if (id) {
        setGeetGovindId(id);
      } else {
        console.warn('GeetGovindDetailPage - No valid ID found in state');
      }
    } else {
      console.warn('GeetGovindDetailPage - No state available');
    }
  }, [location]);

  useEffect(() => {
    console.log('GeetGovindDetailPage - Data fetch useEffect triggered, geetgovindId:', geetgovindId);
    if (geetgovindId) {
      setRefresh(false);
      const fetchData = async () => {
        console.log('GeetGovindDetailPage - Starting data fetch for ID:', geetgovindId);
        try {
          const response = await GeetGovindServices.getcurrentGeetGovind(
            geetgovindId
          );         
          const res = await response;

          const prefetched = geetgovindDetail;

          const [geetGovindRes, navRes] = await Promise.all([
            prefetched ? Promise.resolve({ status: true, result: prefetched }) : GeetGovindServices.getGeetGovindDetail(geetgovindId),
            GeetGovindServices.getNavigationDetails(geetgovindId),
          ]);

          if (prefetched) {
            console.log("KalyanDetailPage: using pre-fetched kalyanDetail from navigation state, skipping API call.");
          } else {
            console.log("API Responses - Kalyan:", geetGovindRes, "Nav:", navRes);
          }

          if (geetGovindRes?.status) {
            setDescription({ __html: geetGovindRes.result?.description || "" });
            setGeetGovindDetail(geetGovindRes.result);
            // console.log({ __html: geetGovindRes.result?.description || "" },"asdfasasdfsdfsf")
            setIsLiked(geetGovindRes.result?.isFavourite);
          }         
          // setGeetGovindDetail(res.result);
          // setDescription({ __html: res.result?.description || "" });
          // setIsLiked(res.result.isFavourite);

          // const navRes = await GeetGovindServices.getNavigationDetails(geetgovindId);

          if (navRes?.status) {
            const navigationTree = navRes.result?.navigationTree || [];
            setToc(navigationTree);

            if (navRes.result?.lastPosition) {
              setLastPos(navRes.result.lastPosition);
            }

            const rawFont = navRes.result?.bookFontSize;
            const parsedFont = parseFloat(rawFont);
            setLastFontSize(
              rawFont !== null &&
                rawFont !== undefined &&
                rawFont !== "" &&
                rawFont !== "null" &&
                !isNaN(parsedFont)
                ? parsedFont
                : 100
            );

            if (navRes.result?.navOrder) {
              const totalChapters = navigationTree.length;
              setProgress(totalChapters > 0 ? (navRes.result.navOrder / totalChapters) * 100 : 0);
            } else {
              setProgress(0);
            }
            setNavOrder(navRes.result?.navOrder || 0);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        } finally {
          setLoading(false);
        }
      }
      fetchData();
    }
  }, [refresh, i18n.language, geetgovindId,geetgovindDetail]);

  useEffect(() => {
    setRefresh(false);
    if (geetgovindId) {
      GeetGovindServices.getRelatedGeetGovind(geetgovindId).then((res) => {
        if (res?.status) {
          setRelatedGeetGovind(res.result);
        }
      });
    }
  }, [refresh, i18n.language, geetgovindId]);

  useEffect(() => {
    if (geetgovindId) {
      EpubServices.getbookmark(
        "geetgovindbookmarks",
        geetgovindId
      ).then((res: any) => {
        if (res.status) {
          setBookMarkData(res?.result)
        }
      });
    }
  }, [refresh, i18n.language, userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!hasVisibleDescription && activeTab === "description") {
      if (hasToc) setActiveTab("toc");
    }
  }, [hasVisibleDescription, activeTab, hasToc]);

  useEffect(() => {
    if (!hasToc && activeTab === "toc") {
      if (hasVisibleDescription) setActiveTab("description");
    }
  }, [hasToc, activeTab, hasVisibleDescription]);

  return (
<>
      {geetgovindDetail?.slug ? (
        // <GeetGovindSeo
        //   book={bookDetail}
        //   canonicalPath={`/books/${bookDetail.slug}`}
        // />
        <GeetGovindseo
           geetgovind ={geetgovindDetail}
          canonicalPath={`/magazines/geetgovind/${geetgovindDetail.slug}`}
        />
      ) : null}
   <div
      className="newcontainer"
      style={{
        backgroundColor: "#FFF6E1",
        padding: "1px 0px 4% 0",
        marginTop: 0,
      }}
    >
      <Breadcrumbs
        mainsubBreadCrumb={t("MonthlyMagazine_tr")}
        subBreadCrumb={t("Home_tr")}
        navigatemainsubBreadCrumb={() => {
          navigate(`/`);
        }}
        subBreadCrumbTwo={t("magazine_tr")}
        navigatesubBreadCrumb={() => {
          navigate(`/magazines`);
        }}
        subBreadCrumbThree={t("MonthlyMagazine_tr")}
        navigatethreeBreadCrumb={() => {
          navigate(`/magazines/geetgovind`);
        }}
        subBreadCrumbFour={geetgovindDetail?.name}
      />
      <div className="container">
        <div className="row">
          <div>
            {geetgovindDetail ? (
              <div
                className="containers card-gst"
                style={{
                  width: "100%",
                  marginTop: "25px",
                  backgroundColor: "#FFFAF0",
                  boxShadow: "0px 0px 10px 0px #dcd1b8",
                }}
              >
                <div className="mat-card row" key={`book-${geetgovindDetail.id}`}>
                  <div style={{ padding: "0px 0px 0 0px", margin: "0 0 0 0" }}>
                    <div className="single-product col-lg-3">
                      <div
                        style={{
                          border: "1px solid #eadfc8",
                          padding: "30px",
                          background: "#fff",
                          borderRadius: "5px",
                          textAlign: "center",
                          width: "125%",
                        }}
                      >
                        <img
                          src={geetgovindDetail.monthlyMagazineThumbPath}
                          onError={(e) => {
                            e.currentTarget.src = DefaultBook;
                          }}
                          onClick={() => setShowCoverPopup(true)}
                          alt={geetgovindDetail.name}
                          title={geetgovindDetail.name}
                          className="bkdetailimg"
                          style={{ cursor: "pointer" }}
                          width="256"
                          height="365"
                        />
                      </div>
                    </div>

                    <div className="single-product-author col-lg-8">
                      <div className="single-book-heading">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <h1
                            style={{
                              fontFamily: "ChanakyaUni",
                              fontSize: "40px",
                              color: "#472d1e",
                              marginTop: "7px",
                            }}
                          >
                            {geetgovindDetail.name}
                          </h1>
                          <label
                            onClick={() => {
                              if (!userId) setLogIn(true);
                            }}
                            style={{ display: "flex", margin: 0 }}
                          >
                            <label style={{ display: bookMarkData?.length > 0 ? "block" : "none", marginRight: "10px" }}>
                              <div className="bkmarkicon"
                                onClick={() => {
                                  setBookMark(bookMark === true ? false : true)
                                }}>
                                <div>
                                  <img src={bookmarkIcon} style={{ width: "45px", height: "45px" }} alt="bookmaarkicon" />
                                </div>
                                <div>
                                  {bookMark && userId && (
                                    <div className="bkmarkicon-style">
                                      <div style={{
                                        display: "flex",
                                        backgroundColor: "#ff6427"
                                      }}>
                                        <p
                                          style={{
                                            color: "#fff",
                                            fontStyle: "normal",
                                            lineHeight: "normal",
                                            borderBottom: "none",
                                            padding: "0 0 0 10%",
                                            margin: 0,
                                          }}>{t("bk_mark_tr")}</p>
                                        <img src={closeicon} style={{ width: "20px", height: "20px", margin: "4px 0 0 10px", cursor: "pointer" }} onClick={() => setBookMark(false)} alt="" />
                                      </div>
                                      <ol style={{ paddingLeft: "20px", fontSize: "20px" }}>
                                        {bookMarkData && bookMarkData?.map((item: any, index: number) => (
                                          <li onClick={() => {
                                            navigate(`/reader/geetgovind/` + geetgovindDetail.slug, {
                                              state: {
                                                magazineDetailId: geetgovindDetail.id,
                                                bookName: geetgovindDetail.name,
                                                chapterName: item?.name,
                                                slug: geetgovindDetail.slug,
                                                location: item?.cfi,
                                                type: BookContentType.magazine,
                                              },
                                            });
                                          }}>
                                            <p style={{ borderBottom: "none", padding: 0, margin: "0 0 0 5px", color: "#000", cursor: "pointer" }}>{item?.name}</p></li>
                                        ))}
                                      </ol>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </label>

                            <label
                              onClick={() => {
                                toggleLike();
                                notify();
                              }}
                            >
                              <img
                                src={isLiked ? Favfill : Favempty}
                                alt="Favicon"
                                style={{ width: "45px", cursor: "pointer" }}
                              />
                            </label>
                            {UserIdentity && geetgovindDetail?.pdfPath && geetgovindDetail.pdfPath !== "null" && geetgovindDetail.pdfPath.trim() !== "" && (
                              <label
                                onClick={() => {
                                  window.open(`/pdf-viewer?pdf=${encodeURIComponent(geetgovindDetail.pdfPath)}`, '_blank');
                                }}
                                style={{ marginLeft: "10px" }}
                              >
                                <img
                                  src={PdfIcon}
                                  alt="PDF Viewer"
                                  style={{ width: "45px", cursor: "pointer" }}
                                />
                              </label>
                            )}
                          </label>
                        </div>
                      </div>
                      {geetgovindDetail.author ? (
                        <div>
                          <p>
                            <label>{t("Authors_tr")} </label>
                            {geetgovindDetail.author}
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                      {geetgovindDetail.geetgovindLanguage ? (
                        <div>
                          <p>
                            <label>{t("Language_tr")} </label>
                            {geetgovindDetail.geetgovindLanguage}
                          </p>
                        </div>
                      ) : (
                        ""
                      )}
                      <div className="bookdecription">
                        <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderTopLeftRadius: "5px", borderBottomLeftRadius: "5px" }}>
                          <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", margin: '0 40% 0 0', paddingBottom: 0 }}>{t("Year_tr")}</label>
                          <label style={{ fontSize: "23px", color: "#ff731f" }}>{geetgovindDetail?.years}</label>
                        </div>
                        <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderLeft: 0, borderRight: 0 }}>
                          <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", margin: '0 40% 0 0' }}>{t("Month_tr")}</label>
                          <label style={{ fontSize: "23px", color: "#ff731f" }}>{monthName}</label>
                        </div>
                        <div className="yearmonth" style={{ display: "flex", justifyContent: "center", border: "1px solid #ffaf68", paddingTop: "15px", borderTopRightRadius: "5px", borderBottomRightRadius: "5px" }}>
                          <label style={{ color: "#472d1e", fontSize: "23px", fontFamily: "ChanakyaUni", margin: '0 40% 0 0' }}>{t("Number_tr")}</label>
                          <label style={{ fontSize: "23px", color: "#ff731f" }}>{geetgovindDetail?.editionNo}</label>
                        </div>
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <div ref={notificationRef} style={{ color: "#ff3d28", fontSize: '20px', marginBottom: "10px" }} className="notification-bar"></div>
                        <div className="actions">
                          {navOrder > 0 && (
                            <div className="book-progress">
                              <div className="book-progress__label">{Math.round(progress)} %</div>
                              <div className="book-progress__track">
                                <div className="book-progress__value" style={{ width: `${progress}%` }}></div>
                              </div>
                            </div>
                          )}
                          <div className="buttons">
                            {navOrder === 0 ? (
                              <button
                                className="btn-book-action"
                                onClick={() => {
                                  if (UserIdentity) {
                                    navigate(`/reader/geetgovind/` + geetgovindDetail.slug, {
                                      state: {
                                        magazineDetailId: geetgovindDetail.id,
                                        bookName: geetgovindDetail.name,
                                        slug: geetgovindDetail.slug,
                                        type: BookContentType.magazine,
                                      },
                                    });
                                  } else {
                                    setLogIn(true);
                                  }
                                }}
                              >
                                {t("read_magazine_tr")}
                              </button>
                            ) : (
                              <>
                                <button
                                  className="btn-book-action"
                                  onClick={() => {
                                    if (UserIdentity) {
                                      navigate(`/reader/geetgovind/` + geetgovindDetail.slug, {
                                        state: {
                                          magazineDetailId: geetgovindDetail.id,
                                          bookName: geetgovindDetail.name,
                                          slug: geetgovindDetail.slug,
                                          type: BookContentType.magazine,
                                        },
                                      });
                                    } else {
                                      setLogIn(true);
                                    }
                                  }}
                                >
                                  {t("Read_From_Start_tr")}
                                </button>
                                <button
                                  className="btn-book-action"
                                  onClick={() => {
                                    navigate(`/reader/geetgovind/` + geetgovindDetail.slug, {
                                      state: {
                                        magazineDetailId: geetgovindDetail.id,
                                        bookName: geetgovindDetail.name,
                                        slug: geetgovindDetail.slug,
                                        location: lastPos,
                                        type: BookContentType.magazine,
                                        fontsize: lastFontSize,
                                      },
                                    });
                                  }}
                                >
                                  {t("Continue_Reading_tr")}
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style={{ margin: "0 05px 5% 05px" }}>
                  <div className="tabs-container">
                    <div className="tabs-line">
                      <div className="tabs" role="tablist">
                        {hasRelateds && (
                          <button
                            className="tabLarge"
                            aria-selected={activeTab === 'related'}
                            onClick={() => setActiveTab('related')}
                          >
                            {t("Related_monthlymagazine_tr")}
                          </button>
                        )}
                        {hasVisibleDescription && (
                          <button
                            className="tab"
                            aria-selected={activeTab === "description"}
                            onClick={() => setActiveTab("description")}
                          >
                            {t("Description_tr")}
                          </button>
                        )}
                        {hasToc && (
                          <button
                            className="tab"
                            aria-selected={activeTab === "toc"}
                            onClick={() => setActiveTab("toc")}
                          >
                            {t("Table_of_Contents_tr")}
                          </button>
                        )}
                      </div>
                      <div
                        className="tab-indicator"
                        style={{
                          transform: `translateX(${indicatorTranslate})`,
                          width: "140px",
                        }}
                      ></div>
                    </div>

                    <div className="tab-panels">
                      {hasRelateds && activeTab === 'related' && (
                        <div className="panel active">
                          <div style={{ margin: "20px" }}>
                            <div className="clsslide row">
                              <div>
                                <div style={{ paddingBottom: "20px", width: "97%", position: "relative", left: "18px" }}>
                                  <Slider {...settings} infinite={relateds && relateds.length > 5}>
                                    {relateds && relateds.map((related: any) => (
                                      <div
                                        className="slider-books sidebarmargin"
                                        key={`related-${related.id}`}
                                        onClick={() => {
                                           navigate(`/magazines/geetgovind/${related.slug}`, {
                                            state: {
                                              geetgovindId: related.id,
                                              geetgovindSlug: related.slug
                                            }
                                          });
                                        }}
                                      >
                                        <div>
                                          <img
                                            src={related.monthlyMagazineThumbPath || DefaultBook}
                                            onError={(e: any) => e.currentTarget.src = DefaultBook}
                                            className="imgcenter"
                                            style={{ cursor: "pointer", borderRadius: 0 }}
                                            alt={related.name}
                                            title={related.name}
                                            width="150"
                                            height="212"
                                          />
                                          <p style={{ fontFamily: "ChanakyaUni" }}>{related.name}</p>
                                        </div>
                                      </div>
                                    ))}
                                  </Slider>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {hasVisibleDescription && (
                        <div className={`panel ${activeTab === "description" ? "active" : ""}`}>
                          <div dangerouslySetInnerHTML={createMarkup()}></div>
                        </div>
                      )}

                      {hasToc && (
                        <div className={`panel ${activeTab === "toc" ? "active" : ""}`}>
                          <ul className="toc">
                            {navigationTree.map((node: any, idx: number) => renderTocNode(node, idx))}
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {/* Related slider moved to tabs */}
              </div>
            ) : (
              <div className="ebooks-category resultnotfound">
                {loading && <Loader loading={loading} />}
                {t("result_not_found_tr")}
              </div>
            )}
          </div>
        </div>
        <LogInModel opens={logIn} onCloses={closeModal} onLoginStateChange={handleLoginStateChange} />
        {geetgovindDetail && (
          <BookCoverPopup
            show={showCoverPopup}
            onClose={() => setShowCoverPopup(false)}
            imagePath={geetgovindDetail.monthlyMagazineThumbPath}
            bookName={geetgovindDetail.name}
          />
        )}
      </div>
    </div>
</>
  );
};
export default GeetGovindDetailPage;
